import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import './styles/SocialsHeader.css';

export default function SocialsHeader({ close, type }) {

  return (
    <>
      <div className="artwork-view-socials-header__container element-non-selectable">
        <Text className="artwork-view-socials-header__text" medium>
          {
            type === "thoughts" ?
              "Thoughts"
              :
              "Ratings"
          }
        </Text>
                
        <XIcon className='artwork-view-socials-header-XIcon' onClick={close}/>
      </div>
    </>
  );
}
